module.exports = __webpack_public_path__ + "assets/loyalty-promotion-registration.9f1dc0a0.svg";